import { create } from "zustand";

export const useFilterActas = create((set) => ({
  filterFields: {
    plate: null,
    notificador: null,
    zona: null,
    localidad: null,
    documento_titular: null,
    motivo: null,
    numero_acta: null,
    tipo: null,
    fecha_desde: null,
    fecha_hasta: null,
  },
  orderBy: {
    orderField: "fecha_hora",
    orderBy: "asc",
  },
  paginateCfg: null,

  setFilterFields: (key, value) => {
    set((state) => {
      return {
        filterFields: {
          ...state.filterFields,
          [key]: value,
        },
      };
    });
  },

  returnResetFilterFields: () => {
    set({
      filterFields: {
        plate: "",
        notificador: "",
        zona: "",
        localidad: "",
        documento_titular: "",
        motivo: "",
        numero_acta: "",
        tipo: "",
        fecha_desde: "",
        fecha_hasta: "",
      },
      orderBy: {
        orderField: "fecha_hora",
        orderBy: "asc",
      },
    });
  },

  setOrderBy: (orderField) => {
    set((state) => {
      return {
        orderBy: {
          orderField: orderField,
          orderBy: state.orderBy.orderBy == "asc" ? "des" : "asc",
        },
      };
    });
  },

  setPaginateCfg: (cfg) => {
    // console.log(cfg)
    set({ paginateCfg: cfg });
  },
}));
